import { Select } from '@app/components/core/input/select/Select'
import Row from '@app/components/layout/Row'
import { useTranslations } from '@i18n/useLanguage'
import { Dispatch } from 'react'
import { useQuery } from '@based/sdk/react'
import { SearchSelectOption } from '@app/components/core/input/searchSelect/SearchSelect'
import { LocalitySelector } from '../../smartInputs/LocalitySelector'

export const SupportingInfoForm = ({
  residence,
  ageCategory,
  searchRegionId,
  setResidence,
  setAgeCategory,
  setSearchRegionId,
}: {
  residence: SearchSelectOption
  ageCategory: number | null
  searchRegionId: string
  setResidence: Dispatch<React.SetStateAction<SearchSelectOption>>
  setAgeCategory: Dispatch<React.SetStateAction<number | null>>
  setSearchRegionId: Dispatch<React.SetStateAction<string>>
}) => {
  const translations = useTranslations().app

  const regionQuery = useQuery('suggestions-region')
  const ageCategoryQuery = useQuery('list-age-categories')

  const allRegions: { id: number; name: string }[] = regionQuery.data ?? []
  const ageCategories: { id: number; name: string }[] =
    ageCategoryQuery.data ?? []

  return (
    <>
      <Row style={{ flexWrap: 'wrap' }}>
        <LocalitySelector
          label={translations.dashboard.profile.location}
          locality={residence}
          setLocality={setResidence}
        />
        <Select
          label={translations.auth.ageCategory}
          value={ageCategory?.toString()}
          setValue={(value) => setAgeCategory(value ? Number(value) : null)}
          notSelectedLabel={translations.auth.ageCategoryPlaceholder}
          options={ageCategories.map((category) => ({
            value: category.id.toString(),
            label: category.name,
          }))}
          containerStyle={{ flex: '1 1 0' }}
        />
      </Row>
      <Row>
        <Select
          label={translations.auth.searchRegion}
          value={searchRegionId}
          setValue={(value) => setSearchRegionId(value)}
          notSelectedLabel={translations.auth.searchRegionPlaceholder}
          options={allRegions.map((region) => ({
            value: region.id.toString(),
            label: region.name,
          }))}
          containerStyle={{ flexGrow: 1 }}
        />
      </Row>
    </>
  )
}
